import { AlertController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class LoginServiceProvider {

    private mensagem: Array<any>;
    private url: string = '';
    
    constructor(private http: Http, private alertCtrl: AlertController) {

    }

    fetchData(username: string, password: string, rest: string): Promise<any> {

        this.url = rest + '/vmlogin';

        let alertctrl = this.alertCtrl.create({
            title: 'Falha no Login',
            subTitle: 'Falha no Login',
            buttons: ['Fechar']
        });

        return new Promise(resolve => {
            this.http.get(this.url + "?username=" + username + "&password=" + password).map(res => res.json())
                .subscribe(
                data => {
                    this.mensagem = data;
                    resolve(this.mensagem);
                }, err => {
                    if (err.json().errorMessage) {
                        alertctrl.setSubTitle(err.json().errorMessage);
                        alertctrl.present();
                    } else {
                        resolve(false);
                    }
                })
        });

    }
}



// WEBPACK FOOTER //
// ./src/providers/login-service.ts